
var $languageSwitcher,
    $toggle,
    $urlNL,
    $urlEN,
    $link;

$(document).ready(function ($) {
  $languageSwitcher = $('.js-language-switcher');
  $toggle = $languageSwitcher.find('.js-toggle')

  $urlNL = $languageSwitcher.find('.js-label').first().data('link');
  $urlEN = $languageSwitcher.find('.js-label').last().data('link');
  
  $toggle.change(function () {
    if ($(this).is(":checked")) {
      $link = $urlEN;
    } else {
      $link = $urlNL;
    }
    window.location.replace($link);
  });

  if (window.location === $urlEN) {
    $toggle.prop("checked", true);
    $languageSwitcher.find('.js-label').first().removeClass('is-active');
    $languageSwitcher.find('.js-label').last().addClass('is-active');
  }

  if (window.location === $urlNL) {
    $toggle.prop("checked", false);
    $languageSwitcher.find('.js-label').first().addClass('is-active');
    $languageSwitcher.find('.js-label').last().removeClass('is-active');
  }
});
